
export interface VideoUrlValidationResult {
  isValid: boolean;
  provider?: 'youtube' | 'vimeo' | 'other';
  errorMessage?: string;
  videoId?: string;
}

export const validateVideoUrl = (url: string): VideoUrlValidationResult => {
  if (!url || url.trim() === '') {
    return { isValid: true }; // Empty URLs are allowed
  }

  const trimmedUrl = url.trim();

  // YouTube validation
  const youtubeRegex = /^https?:\/\/(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]+/;
  if (youtubeRegex.test(trimmedUrl)) {
    let videoId = '';
    if (trimmedUrl.includes('youtube.com/watch?v=')) {
      videoId = trimmedUrl.split('v=')[1]?.split('&')[0] || '';
    } else if (trimmedUrl.includes('youtu.be/')) {
      videoId = trimmedUrl.split('youtu.be/')[1]?.split('?')[0] || '';
    }
    return {
      isValid: true,
      provider: 'youtube',
      videoId
    };
  }

  // Vimeo validation
  const vimeoRegex = /^https?:\/\/(www\.)?vimeo\.com\/[0-9]+/;
  if (vimeoRegex.test(trimmedUrl)) {
    const videoId = trimmedUrl.split('vimeo.com/')[1]?.split('?')[0] || '';
    return {
      isValid: true,
      provider: 'vimeo',
      videoId
    };
  }

  // Basic URL validation for other providers
  try {
    new URL(trimmedUrl);
    return {
      isValid: true,
      provider: 'other'
    };
  } catch {
    return {
      isValid: false,
      errorMessage: 'Please enter a valid video URL. Supported formats:\n• YouTube: https://youtube.com/watch?v=... or https://youtu.be/...\n• Vimeo: https://vimeo.com/...\n• Other video platforms with valid URLs'
    };
  }
};

export const getVideoUrlExamples = () => [
  'https://youtube.com/watch?v=dQw4w9WgXcQ',
  'https://youtu.be/dQw4w9WgXcQ',
  'https://vimeo.com/123456789'
];

export const getSupportedPlatforms = () => [
  'YouTube',
  'Vimeo',
  'Other video platforms'
];
